import AdminPanel from '../components/AdminPanel';
import { useAppContext } from '../context/AppContext';

export default function AdminPage() {
  const { setCurrentPage } = useAppContext();
  return (
    <AdminPanel onClose={() => setCurrentPage('home')} inline />
  );
}